import React from "react";
import { Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { colors } from "../../lib/constant";
import { IconIos24 } from "../../icons-ts";
import { Title } from "./Title";
import { fontFamily, fontSize, product_sans } from "../../lib/fonts";
import { mediaQuery } from "react-styled-mediaquery";

const Container = styled(Row)`
  width: 100%;
  background: linear-gradient(
    315deg,
    ${colors.primary} 0%,
    ${colors.primaryLt} 100%
  );
  margin: 0;
  border-radius: 10px;
  padding: 60px;
  box-shadow: 0 10px 30px 0 rgba(27, 22, 51, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery("<=", "tablet")`
    padding: 25px 0;
    flex-direction: column;
  `}

  ${mediaQuery("<=", "phablet")`
    padding: 25px;
  `}
`;

const TitleCard = styled(Title)`
  color: #fff;
  ${fontSize("30px")}
  line-height: 41px;
  ${fontFamily(product_sans.medium)};
  margin-bottom: 0;
  text-align: center;

  ${mediaQuery(">", "tablet")`
  text-align: right;
  margin-right: 30px;
  `}

  ${mediaQuery("<=", "tablet")`
    ${fontSize("20px")}
    line-height: 28px;
  `}
`;

const CardContainer = styled.div`
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 150px;
  height: 150px;
  padding: 30px;
  box-sizing: border-box;
  margin-left: 30px;

  ${mediaQuery("<=", "phablet")`
    min-width: auto;
    height: auto;
    padding: 10px;
  `}

  ${mediaQuery("<=", "tablet")`
    display: flex;
    margin-top: 30px;

    &:first-child { margin-left: 0; }
  `}
`;

const CardTitle = styled.div`
  color: #ffffff;
  ${fontFamily(product_sans.medium)};
  ${fontSize("11px")}
  line-height: 15px;
  margin-top: auto;
`;

const CardDesc = styled.div`
  color: #ffffff;
  ${fontFamily(product_sans.bold)};
  ${fontSize("18px")}
  line-height: 24px;
  color: #ffffff;
  margin-top: 5px;
`;

const Cards = styled.div`
  display: flex;
`;

const CardPlatform = ({
  icon,
  title,
  desc,
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) => (
  <CardContainer>
    <div>{icon}</div>
    <CardTitle>{title}</CardTitle>
    <CardDesc>{desc}</CardDesc>
  </CardContainer>
);

export const CardDevices = () => (
  <Container>
    <TitleCard htmlLevel={2}>
      Application disponible aussi sur tablette
    </TitleCard>

    <Cards>
      <CardPlatform
        icon={<IconIos24 width="24" fill="#fff" />}
        title="Sur votre iPad"
        desc="iOS"
      />
    </Cards>
  </Container>
);
